import { __decorate } from "tslib";
/**
@license
Copyright 2018 Google Inc. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import { customElement } from 'lit-element';
import { DrawerBase } from './mwc-drawer-base.js';
import { style } from './mwc-drawer-css.js';
let Drawer = class Drawer extends DrawerBase {
};
Drawer.styles = style;
Drawer = __decorate([
    customElement('mwc-drawer')
], Drawer);
export { Drawer };
//# sourceMappingURL=mwc-drawer.js.map